import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Dropdown } from "react-bootstrap";
import { getCookie, setCookie } from "../../utils/cookie-service";
import { Link } from "react-router-dom";
import routes from "../../constants/routes";
import defaultLogo from "../../assets/img/default-company-logo.jpg";
import { FaHandsHelping } from "react-icons/fa";
import { PiUserSwitchBold } from "react-icons/pi";
import { add, update, getById } from "../../store/global/actions";
import { API_ENDPOINT } from "../../store/api-action";
import { connect } from "react-redux";
import empIcon from "./../../assets/img/temp-emp-icon.png";
import { UPDATE_USER } from "../../store/mutations";
import ErrorModal from "./modals/ErrorModal";

function Header(props) {
  const compId = useSelector((state) => state.global.companyId);
  const empId = useSelector((state) => state.global.employeeId);
  const [detailsList, setDetailsList] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const authUser = useSelector((state) => state.auth.currentUser);
  const dispatch = useDispatch();
  const employeeId = empId ? empId : getCookie("hrms-employeeId");
  const companyList = JSON.parse(localStorage.getItem("companyList"));
  const companyDetail = JSON.parse(localStorage.getItem("companyDetails"));
  const [selectedCompany, setSelectedCompany] = useState(companyDetail?.name);

  const getAccessFromCookie = () => {
    try {
      const encoded = getCookie("access");
      return encoded ? JSON.parse(atob(encoded)) : null;
    } catch (err) {
      console.error("Failed to decode access cookie:", err);
      return null;
    }
  };

  const switchUserHandler = () => {
    const access = getAccessFromCookie(); // get access data
    const currentUserType = getCookie("authUser") || "User";
    if (currentUserType === "Admin") {
      //  switching to ESS
      if (access?.ess) {
        dispatch({ type: UPDATE_USER, payload: "User" });
        setCookie("authUser", "User");
      } else {
        setErrorMessage("You don't have ESS access");
        setShowErrorModal(true); // Show the error modal
      }
    } else {
      //  switching to Admin
      if (access?.admin) {
        dispatch({ type: UPDATE_USER, payload: "Admin" });
        setCookie("authUser", "Admin");
      } else {
        setErrorMessage("You don't have Admin access");
        setShowErrorModal(true); // Show the error modal
      }
    }
  };

  const onchangeCompany = async (data) => {
    setCookie("hrms-companyId", data.uuid);
    localStorage.setItem("companyDetails", JSON.stringify(data));
    setSelectedCompany(data.name);
    window.location.reload();
  };

  const getEmployeeDetails = async () => {
    const { getById } = props;

    if (authUser == "User" && employeeId) {
      const response = await getById(
        `${API_ENDPOINT.employee.getEmployee}/${employeeId}`
      );
      if (response) {
        setDetailsList(response);
      }
    }
  };

  useEffect(() => {
    if (authUser === "User" && employeeId) {
      getEmployeeDetails();
    }
  }, [authUser, employeeId]);

  return (
    <header className="topbar">
      <nav className="navbar navbar-expand py-0">
        <div className="d-flex align-items-center gap-2">
          <div className="sidebar-header-main-logo">
            <Link
              to={
                authUser === "Admin" ? routes.dashboard : routes.ess.dashboard
              }
            >
              <img
                src={companyDetail?.reportLogo || defaultLogo}
                alt="Logo"
                className="pe-none"
              />
            </Link>
          </div>
          <label htmlFor="toggle-menu-desktop" className="toggle-menu-desktop">
            <i
              className={`fa fa-list cursor-pointer`}
              style={{ color: "var(--secondary-color)" }}
            ></i>
          </label>
          <label htmlFor="toggle-menu-mobile" className="toggle-menu-mobile">
            <i
              className={`fa fa-list cursor-pointer`}
              style={{ color: "var(--secondary-color)" }}
            ></i>
          </label>

          {authUser === "Admin" && (
            <div className="choose-comp-head">
              <Dropdown
                drop="down"
                popperConfig={{
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, 8],
                      },
                    },
                  ],
                }}
              >
                <Dropdown.Toggle className="company-select border-none d-flex justify-content-between align-items-center">
                  <span className="text-truncate overflow-hidden w-100">
                    {selectedCompany || "Select company"}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {companyList?.map((company) => (
                    <Dropdown.Item
                      key={company.uuid}
                      onClick={() => onchangeCompany(company)}
                    >
                      {company.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
        <div className="top-menu ms-auto me-md-2 ">
          {authUser === "User" && (
            <div className="top-menu ms-auto ">
              <Link
                to={routes.ess.queryManagement.queryManagement}
                className="text-decoration-none btn btn-primary ms-md-4 btn-sm small-text"
              >
                <p className="mb-0 fw-bold">
                  <FaHandsHelping className="me-2" />
                  Help Desk
                </p>
              </Link>
            </div>
          )}
        </div>

        <div className="user-box dropdown">
          <a
            className="d-flex flex-wrap align-items-center justify-content-center nav-link dropdown-toggle dropdown-toggle-nocaret"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src={detailsList?.profilePic || empIcon}
              className="user-img"
              alt="user avatar"
            />
            <div className="user-info ps-md-3 ps-1 ">
              <p className="text-center">{authUser}</p>
              {detailsList && (
                <p style={{ fontSize: "12px", textAlign: "center" }}>
                  {detailsList?.firstName} &nbsp;
                  {detailsList?.lastName}
                  <br />
                  <span style={{ fontSize: "10px" }}>
                    ({detailsList?.employmentDetail[0]?.employeeCode})
                  </span>
                </p>
              )}
            </div>
          </a>

          <ul className="dropdown-menu dropdown-menu-end">
            {authUser === "User" ? (
              <li>
                <Link to={routes.ess.profile} className="dropdown-item">
                  Profile
                </Link>
              </li>
            ) : (
              <li>
                <Link to={routes.dashboard} className="dropdown-item">
                  Dashboard
                </Link>
              </li>
            )}

            <li>
              <Link to="/auth/logout" className="dropdown-item botder-top">
                Logout
              </Link>
            </li>
          </ul>
        </div>
        <Link
          to=""
          href="#"
          className="px-md-2 px-1 switch-to-icon"
          title={
            authUser === "Admin" ? "Switch to Ess User" : "Switch to Admin"
          }
        >
          <PiUserSwitchBold onClick={switchUserHandler} />
        </Link>
      </nav>
      {showErrorModal && (
        <ErrorModal
          show={showErrorModal}
          handleClose={() => setShowErrorModal(false)}
          errorMessage={errorMessage}
        />
      )}
    </header>
  );
}
export default connect((state) => ({ companyId: state.global.companyId }), {
  add,
  update,
  getById,
})(Header);
